import React from "react";

import Close from "../../assets/images/cancel.svg";

import "./mobile-side-nav.scss";

const MobileSideNav = (props) => {
  const handleSidenav = () => {
    props.closeSidenav();
  };
  return (
    <div className="side-menu__container">
      <img
        src={Close}
        alt="Close side nav"
        className="close_icon"
        onClick={handleSidenav}
      />
      <nav className="side-menu_body">
        <ul className="side-nav_ul">
          <li>
            <a href="/" className="side-nav_link">
              HOME
            </a>
          </li>
          <li>
            <a href="/about" className="side-nav_link">
              ABOUT
            </a>
          </li>
          <li>
            <a href="/team" className="side-nav_link">
              TEAM
            </a>
          </li>
          <li>
            <a href="/contact" className="side-nav_link">
              CONTACT
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MobileSideNav;
